const metadata = {
  description: "watch ETH become ultra sound money",
  title: "Ultra Sound Money",
  image: "https://ultrasound.money/og-image.png",
};

export default metadata;
